import type { Fallacy } from "./types";
import { createStory } from "./types";

export const escalationTrap: Fallacy = {
    id: "escalation-trap",
    name: "Escalation Trap",
    emoji: "🪜",
    category: "Jebakan Strategi",
    description: "Terlalu **gengsi mundur**, terus **eskalasi** sampai semua rugi.",
    tldr: "\"Masa kalah? Tambahin lagi!\" — sampai biaya eskalasi jauh melebihi nilai kemenangan.",
    detail: "Escalation Trap terjadi ketika dua pihak atau lebih terjebak dalam siklus **saling meningkatkan taruhan**, bukan karena hasilnya sepadan, melainkan karena **gengsi, ego, atau ketakutan terlihat lemah**. Semakin lama berlanjut, semakin besar kerugian — tapi semakin sulit berhenti.\n\nContoh: perang harga antar bisnis karena gengsi sampai dua-duanya rugi. Di media sosial, debat kecil jadi perang komentar berjam-jam karena tidak ada yang mau \"kalah\" dengan berhenti membalas.\n\nKuncinya: hitung biaya total, bukan hanya yang sudah dikeluarkan. **Mundur bukan berarti kalah** — kadang mundur adalah strategi paling rasional ketika biaya melanjutkan sudah melampaui nilai kemenangan.",
    story: createStory("Escalation Trap", "🪜", {
      hook: {
        title: "\"Masa kalah? Tambahin lagi!\"",
        body: "Debat 3 jam di Twitter, perang harga sampai bangkrut, pagar ditinggiin terus... karena gak mau kalah.",
      },
      convo: {
        claim: "Udah 3 jam debat sama orang random di Twitter, capek sih. Tapi aku gak mau berhenti, **bales terus sampai dia nyerah**.",
        response: "3 jam kamu gak dapet apa-apa. **Berhenti bukan kalah, itu hemat energi.**",
      },
      reveal: {
        body: "Dua pihak terjebak **saling naikin taruhan**, bukan karena sepadan, tapi karena **gengsi dan ego**. Makin lama makin rugi, tapi makin susah berhenti.",
      },
      insight: {
        title: "Yang bikin susah berhenti",
        body: "Kamu ngerasa \"udah keluar banyak, sayang mundur.\" Padahal yang harusnya dihitung bukan yang udah keluar, tapi **berapa lagi yang bakal kebuang kalau terus lanjut**.",
      },
      engagement: {
        title: "Pernah terjebak eskalasi yang gak worth it? 🪜",
        body: "Debat Twitter atau perang harga bisnis? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["sunk-cost", "prisoners-dilemma", "zero-sum-bias"],
  };
